type { Judgment } from ./practice-session.civet

{floor, max, min} := Math

// Points per judged hit, multiplied by the combo tier. Early/late are hits —
// they keep the combo alive — but score like grazes.
export POINTS := { perfect: 100, good: 50, early: 25, late: 25 }
// Wrong notes forgiven per combo run before one breaks it. Misses always break.
export WRONG_FORGIVENESS := 2

// Health: hits heal a little, misses hurt a lot, wrong notes sting (combo
// forgiveness doesn't shield health). At zero the pass fails.
export HEALTH_GAIN := { perfect: 0.02, good: 0.015, early: 0.01, late: 0.01 }
export HEALTH_MISS_COST := 0.1
export HEALTH_WRONG_COST := 0.04

// Score/combo state for one Game Mode pass. Pure — judgments feed in, display
// values fall out; the caller owns when a pass starts and ends.
export class GameScore
  score = 0
  combo = 0
  maxCombo = 0
  // wrong notes forgiven since the combo last broke
  forgiven = 0
  // 0..1; the pass fails when it empties
  health = 1

  // ×1 for the first ten hits of a combo, one more per ten, capped at ×4
  multiplier(): number
    min 4, 1 + floor @combo / 10

  failed(): boolean
    @health <= 0

  judge(judgment: Judgment): void
    switch judgment
      when "perfect", "good", "early", "late"
        @combo++
        @maxCombo = max @maxCombo, @combo
        @score += POINTS[judgment] * @multiplier()
        @health = min 1, @health + HEALTH_GAIN[judgment]
      when "miss"
        @breakCombo()
        @health = max 0, @health - HEALTH_MISS_COST
      when "wrong"
        if @forgiven < WRONG_FORGIVENESS
          @forgiven++
        else
          @breakCombo()
        @health = max 0, @health - HEALTH_WRONG_COST

  breakCombo(): void
    @combo = 0
    @forgiven = 0

// Quality-weighted hit rate against every chart note in the pass, 0–1.
// Wrong notes don't enter — they already cost score through the combo.
export accuracy := (stats: {perfect: number, good: number, early: number, late: number, miss: number}): number ->
  total := stats.perfect + stats.good + stats.early + stats.late + stats.miss
  return 0 unless total
  (stats.perfect + 0.7 * stats.good + 0.4 * (stats.early + stats.late)) / total

export grade := (acc: number): string ->
  if acc >= 0.95 then "S"
  else if acc >= 0.9 then "A"
  else if acc >= 0.8 then "B"
  else if acc >= 0.7 then "C"
  else if acc >= 0.5 then "D"
  else "F"

export default GameScore
